var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Hr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.1875L6.25 0L0 2.1875V7.225C0 9.80437 1.58375 11.6075 3.06 12.7269C3.9513 13.3959 4.92889 13.9415 5.96625 14.3488C6.03708 14.3754 6.10833 14.4008 6.18 14.425L6.25 14.45L6.32125 14.425C6.45791 14.3775 6.59336 14.3267 6.7275 14.2725C7.69359 13.8745 8.60508 13.3551 9.44 12.7269C10.9169 11.6075 12.5 9.80437 12.5 7.225V2.1875ZM5.62563 9.35938L2.975 6.7075L3.85875 5.82313L5.62625 7.59125L9.16187 4.05562L10.0462 4.93938L5.62563 9.35938Z",
    fill: "#5D44FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Hr);
export default __webpack_public_path__ + "static/media/24-hr.75e05d8e46f366d6432f88108981cf86.svg";
export { ForwardRef as ReactComponent };